import { action } from '@/lib/api';
import { getList } from '@/redux/actions/gravityActions.js';
import { store } from '@/redux/lib/configureStore';

const readLookupList = ({ lookupId, listType, callback, force = false }) => {
  const state = store.getState();

  const lookupValue = state?.workflow?.workflowLookups[lookupId]?.data;
  if (!force && lookupValue) {
    callback?.();
    return;
  }

  action('SET_WORKFLOW_LOOKUP', { id: lookupId, data: [] });

  return getList({
    type: listType,
    callback
  });
};

export default readLookupList;
